import { useTranslation } from "hooks/useTranslation";
import { DynamicLink } from "shared/components/DynamicLink";
import styles from "../DropdownContent.module.scss";
import { TECHNOLOGY_LINKS } from "pages/Technology/constants";

export const TechnologyDropdownContent = ({ closeDropdown }) => {
  const { translate } = useTranslation();

  return (
    <div className={styles.container}>
      {TECHNOLOGY_LINKS.map((tl, idx) => (
        <div className={styles.column} key={idx}>
          <div className={styles.titleBlock}>
            <DynamicLink
              className={styles.title}
              key={idx}
              onClick={closeDropdown}
              queryParams={{ name: tl.key }}
              to="/technology"
            >
              { translate(tl.name) }
            </DynamicLink>
          </div>
          <div className={styles.contentBlock}>
            <div className={styles.column}>
              {tl.items.map((pl, idx) => (
                pl.download ? (
                  <DynamicLink
                    isDisabled={pl.isDisabled}
                    onClick={closeDropdown}
                    key={idx}
                    href={pl.link}
                    disables={pl.highlighted}
                    className={`${styles.subTitle} ${
                      pl.highlighted && styles.highlighted
                    } ${pl.isDisabled && styles.isDisabled}`}
                    target="_blank"
                  >
                    { pl.title }
                  </DynamicLink>
                ) : (
                  <DynamicLink
                    isDisabled={pl.isDisabled}
                    onClick={closeDropdown}
                    key={idx}
                    queryParams={{ name: pl.key, ...(pl.option && { option: pl.option }) }}
                    to="/technology"
                    disables={pl.highlighted}
                    className={`${styles.subTitle} ${
                      pl.highlighted && styles.highlighted
                    } ${pl.isDisabled && styles.isDisabled}`}
                  >
                    { translate(pl.title ?? pl.key) }
                  </DynamicLink>
                )
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  )
};